"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequirementType = void 0;
var RequirementType;
(function (RequirementType) {
    RequirementType["OXYGEN"] = "O2";
    RequirementType["TEMPERATURE"] = "C";
    RequirementType["OCEANS"] = "Ocean";
    RequirementType["VENUS"] = "Venus";
    RequirementType["TR"] = "TR";
    RequirementType["RESOURCE_TYPES"] = "Resource type";
    RequirementType["GREENERIES"] = "Greenery";
    RequirementType["CITIES"] = "City";
    RequirementType["COLONIES"] = "Colony";
    RequirementType["FLOATERS"] = "Floater";
    RequirementType["CHAIRMAN"] = "Chairman";
    RequirementType["PARTY_LEADERS"] = "Party leader";
    RequirementType["TAG"] = "tag";
    RequirementType["PRODUCTION"] = "production";
    RequirementType["PARTY"] = "party";
    RequirementType["REMOVED_PLANTS"] = "Removed plants";
    RequirementType["COLONY_RATE"] = "Colony rate";
    RequirementType["MINING_RATE"] = "Mining rate";
    RequirementType["LOGISTIC_RATE"] = "Logistic rate";
    RequirementType["COLONY_TILES"] = "Colony tiles";
    RequirementType["MINING_TILES"] = "Mine tiles";
    RequirementType["ROAD_TILES"] = "Road tiles";
})(RequirementType = exports.RequirementType || (exports.RequirementType = {}));
